import { render, staticRenderFns } from "./ProductsOnLocation.vue?vue&type=template&id=57f7b723&scoped=true&"
import script from "./ProductsOnLocation.vue?vue&type=script&lang=js&"
export * from "./ProductsOnLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7b723",
  null
  
)

export default component.exports